import type { ApiPatchOperation } from '@domain/schemas/api-patch-operation';
import type { UpdateBlockPayloadInput } from '@domain/schemas/payload.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { GetBlockResponse } from '@responses/blocks';
import type { PatchResponse } from '@responses/common';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

type BlockLifecycleOperation =
  ApiPatchOperation.DeactivateBlock | ApiPatchOperation.ReactivateBlock | ApiPatchOperation.RestoreBlock;

type UpdateBlock = {
  (id: string, data: UpdateBlockPayloadInput): Promise<GetBlockResponse>;
  (id: string, data: { operation: BlockLifecycleOperation }): Promise<PatchResponse>;
};

export const updateBlock: UpdateBlock = async (
  id: string,
  data: UpdateBlockPayloadInput | { operation: BlockLifecycleOperation },
) => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `blocks/${id}`,
    data,
  });

  const response = await axios(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['search'] });
  return response.data;
};
